import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonImg, IonIcon, IonItem, IonAlert} from '@ionic/react';
import { useHistory, useParams } from 'react-router-dom';
import ExploreContainer from '../components/ExploreContainer';
import './Home.css';
import React, { useRef, useState, useEffect } from 'react';
import { useIonViewDidEnter, useIonViewDidLeave, isPlatform } from '@ionic/react'
import { PluginListenerHandle } from '@capacitor/core'
import PageEventHandler from "../components/PageEventHandler"
import {appVersion, localStore} from '../App';
import { BASE_URL } from '../utils/constant';
import { App } from '@capacitor/app';
import { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import { homeTranslations } from '../translations/home';
import NotificationRedirect from '../components/NotificationRedirect';

const Home: React.FC = () => {

  const backButtonListenerHandle = useRef<PluginListenerHandle>()
  const [versionNumber, setVersionNumber] = useState('0.0');
  const [showVersionAlert, setShowVersionAlert] = useState(false);
  const { language } = useContext(LanguageContext);
  const t = homeTranslations[language];

  useIonViewDidEnter(() => {
    App.addListener('backButton', () => {
      App.exitApp();
    }).then(listener => {
      backButtonListenerHandle.current = listener;
    });
  });
  

    useIonViewDidLeave(() => {
      if (backButtonListenerHandle.current) {
        backButtonListenerHandle.current.remove()
        backButtonListenerHandle.current = undefined
      }
    })

    // load app version number from server
    async function fetchAppVersion()
    {
      return new Promise(function(resolve,reject)
      {
        const url = `${BASE_URL}/poServer.php?act=7&h=gkzLoFk0MN58TGqCJj`;
        fetch(url)
          .then(res => res.json())
          .then(
            (result) => {
              setVersionNumber(result.content);
              if (result.content != appVersion)
              {
                setShowVersionAlert(true);
              }

              resolve(result.content);
            },
            (error) => {
              console.log('Problema nella ricezione dei dati sulla versione dell\'app: ',error);
                setShowVersionAlert(false);
              // do not give allarming feedback to the user - die silently
              resolve(null);
            }
        );
      });
    }

    // handler for the alert-update button
    function updateBtnHandler()
    {
      if (isPlatform('ios'))
      {
        window.open("https://apps.apple.com/it/app/portolano-del-po/id1624054764");
      }
      else
      {
        window.open("https://play.google.com/store/apps/details?id=art.acma.portolanopo");
      }
    }

    useEffect(() => {
      fetchAppVersion();
    },[versionNumber]);

  const pageName = "Benvenuti a Po";
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonImg class="toolbarImages ion-margin" slot="start" alt="Logo portolano del Po" src={`${process.env.PUBLIC_URL}/assets/images/PortolanoPo-28.png`} />
          <IonButtons slot="end">
            <IonMenuButton>
              <IonIcon src={`${process.env.PUBLIC_URL}/assets/images/portolanoPo-menu.svg`}></IonIcon>
            </IonMenuButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonItem lines="none">
          <h1 className="mainTit">{t.welcomeHeader}</h1>
        </IonItem>
        <NotificationRedirect />
        <ExploreContainer />
        <IonAlert
          header={t.updateHeader}
          isOpen={showVersionAlert} 
          message={t.updateMessage}
          onDidDismiss={() => setShowVersionAlert(false)}
          buttons={[{ text: t.laterButton },{ text: t.updateButton, handler: () => { updateBtnHandler(); },}]}
          />
      </IonContent>
      <PageEventHandler pageIndex={0} dockIndex={0}/>
    </IonPage>
  );
};

export default Home;
